module.exports = __webpack_public_path__ + "static/media/illustration-working.207bd6d9.svg";